import styled from 'styled-components';
import Link from 'next/link';
import { FlexibleDiv } from '../../../../styled/common';
import { Breakpoints } from '../../../../styled/constants';

export const ContactsContainer = styled(FlexibleDiv)`
  flex-wrap: wrap;
  margin-top: 15px;
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-top: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const ContactLink = styled(Link)`
  padding: 10px 15px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  color: ${({ theme }) => theme.colors.systemColors.blue};
  font-size: 15px;
`;
